import React, { useState, useEffect, useContext } from "react";
import { Snackbar, Alert } from "@mui/material";
import {  
  Grid,
  Card,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
// Import your user context/provider here. Adjust as needed.
// Example: import { AuthContext } from "context/AuthContext";
import { apiSearchZones } from "../api/zones";
import { apiGetAgingReport, apiGetTunggakanPerZon } from "../api/tunggakan";
import { printTunggakanPreview } from "components/STPrint/PrintTunggakan";
import { printAgingReportPreview } from "components/STPrint/PrintAgingReport";
import MDBox from "components/MDBox";
import PrintIcon from "@mui/icons-material/Print";
import MDTypography from "components/MDTypography";
import { pageHeaderStyles } from "utils/pageHeaderStyles";
import { buttonStyles } from "utils/buttonStyles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";



export default function Laporan() {
  // For Aging Report Preview
  const [agingEnd, setAgingEnd] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  // For Tunggakan (Per-period unpaid invoices) Preview
  const [arrearsEnd, setArrearsEnd] = useState("");
    // State for Tunggakan by zon
  const [tunggakanData, setTunggakanData] = useState([]);
  const [tunggakanTotal, setTunggakanTotal] = useState(0);
  // Fetch tunggakan by zon up to arrearsEnd (endDate)
  const fetchTunggakan = async () => {
    if (!arrearsEnd) return;
    try {
      const res = await apiGetTunggakanPerZon(null, arrearsEnd);
      setTunggakanData(res.data || []);
      setTunggakanTotal(res.total || 0);
    } catch (err) {
      setSnackbarMsg("Gagal memuatkan data tunggakan.");
      setSnackbarOpen(true);
    }
  };

  // Refetch when arrearsEnd changes
  useEffect(() => {
    fetchTunggakan();
    // eslint-disable-next-line
  }, [arrearsEnd]);

  const handleArrearsPreview = async () => {
    try {
      await printTunggakanPreview(arrearsEnd);
    } catch (err) {
      setSnackbarMsg(err?.message || "Gagal menjana pratonton Tunggakan.");
      setSnackbarOpen(true);
    }
  };
  const handleAgingPreview = async () => {
    try {
      await printAgingReportPreview({ agingEnd, zon: printZon });
    } catch (err) {
      setSnackbarMsg(err?.message || "Gagal menjana pratonton Aging Report.");
      setSnackbarOpen(true);
    }
  };
  // Get current user from context or props. Adjust as needed.
  // Example: const { currentUser } = useContext(AuthContext);
  const currentUser = { bahagian_pemantau: "CURRENT_USER_BAHAGIAN" }; // TODO: Replace with real user

  const [zonOptions, setZonOptions] = useState([]);
  const [printZon, setPrintZon] = useState("SEMUA ZON");

  const fetchDropdowns = async () => {
    try {
      // Fetch zones filtered by bahagian_pemantau
      const res = await apiSearchZones({ bahagian_pemantau: currentUser.bahagian_pemantau }, 1, 100);
      const data = res.data || res.zones || [];
      // Get unique zon values (zon name or code)
      const zonSet = new Set();
      data.forEach((row) => {
        if (row.zon) zonSet.add(row.zon);
        else if (row.nama_zon) zonSet.add(row.nama_zon);
      });
  // Add 'SEMUA ZON' as the first option
  setZonOptions(["SEMUA ZON", ...(zonSet.size ? zonSet : [""])]);
    } catch (e) {
      setZonOptions([""]);
    }
  };

  useEffect(() => {
    fetchDropdowns();
    // eslint-disable-next-line
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2}>
        <Grid container spacing={2}>
          {/* Zones Section */}
          <Grid item xs={12} md={6}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                sx={pageHeaderStyles.report}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Tunggakan
                </MDTypography>
              </MDBox>
              {/* Tunggakan Table */}
              <MDBox p={2} mt={2}>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid item xs={12}>
                    <TextField
                      label="Tarikh (Tunggakan)"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      required
                      value={arrearsEnd}
                      onChange={(e) => setArrearsEnd(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      startIcon={<PrintIcon />}
                      size="small"
                      variant="contained"
                      sx={{ ...buttonStyles.primary, mt: 6, px2: 0, minWidth: 0 }}
                      onClick={handleArrearsPreview}
                    >
                      Preview
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>  
          {/* Categories Section */}
          <Grid item xs={12} md={6}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                sx={pageHeaderStyles.report}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Aging Report
                </MDTypography>
              </MDBox>
              <MDBox p={2} mt={2}>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                  <Grid item xs={12}>
                    <TextField
                      label="Tarikh (Aging)"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      required
                      value={agingEnd}
                      onChange={e => setAgingEnd(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl
                    fullWidth
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "#ffffffff",
                          fontSize: "0.775rem",
                          p: 1.2,
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "0.775rem",
                        },
                      }}
                    >
                      <InputLabel>Zon</InputLabel>
                      <Select
                        value={printZon}
                        label="Zon"
                        onChange={(e) => setPrintZon(e.target.value)}
                      >
                        {zonOptions.map((zon) => (
                          <MenuItem key={zon} value={zon}>
                            {zon === "SEMUA ZON" ? "SEMUA ZON" : zon}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', maxWidth : '100%' }}>
                    <Button
                      startIcon={<PrintIcon />}
                      size="small"
                      variant="contained"
                      sx={{ ...buttonStyles.primary, m: 0, px: 2, minWidth: 0 }}
                      onClick={handleAgingPreview}
                    >
                      Preview
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        {/* Snackbar for error messages */}
        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
            {snackbarMsg}
          </Alert>
        </Snackbar>
      </MDBox>
    </DashboardLayout>
  );
}
